// 包件API
const apiName = process.env.BUILD_ENV === 'dev' ? 'ec-pc-api' : 'ec-pc-api'
const pack = {

  listPage: {
    type: 'post',
    url: `${apiName}/pack/list`
  }

};

export default pack;
